import './App.css';
import Root from "./root/pages/RouteIndex";
import {ToastContainer} from 'react-toastify';
import {BrowserRouter} from "react-router-dom";
import {SessionWrapper} from "./root/redux/Reducers/AuthReducer";
import 'react-toastify/dist/ReactToastify.css';
import "./root/assets/css/global.css"
import {GOOGLE_API_KEY} from "./root/settings/settings";
import {GoogleOAuthProvider} from "@react-oauth/google";
import {SessionExpiredModal} from "./root/Modals/SessionExpired/SessionExpiredModal";
import ScrollToTop from "./root/components/ScrollToTop";


function App() {

    return (
        <GoogleOAuthProvider clientId={GOOGLE_API_KEY}>
            <ToastContainer
                pauseOnFocusLoss={false}
                hideProgressBar={true}

            />
            <BrowserRouter>
                <ScrollToTop/>
                <SessionExpiredModal/>
                <SessionWrapper>

                    <Root/>
                </SessionWrapper>
            </BrowserRouter>
        </GoogleOAuthProvider>

    );
}

export default App;
